// assets/resources/js/core/icons.js

function resolveSpriteUrl() {
    const meta = document.querySelector('meta[name="icon-sprite"]');
    const fromMeta = meta && meta.getAttribute('content');
    const fromData = document.documentElement.getAttribute('data-icon-sprite');
    const fallback = '/themes/<theme>/assets/build/icons/icons-sprite.svg';
    const raw = fromMeta || fromData || fallback;
    return new URL(raw, document.baseURI).href;
}

const SPRITE = resolveSpriteUrl();

function classToSymbolId(cls) {
    const mFa = cls.match(/^fa-(solid|regular|brands)-(.+)$/);
    if (mFa) return `fa-${mFa[1]}-${mFa[2]}`;
    const mTab = cls.match(/^tabler-(outline|filled)-(.+)$/);
    if (mTab) return `tabler-${mTab[1]}-${mTab[2]}`;
    const mRemix = cls.match(/^remix-(.+)$/);
    if (mRemix) return `remix-${mRemix[1]}`;
    const mCustom = cls.match(/^custom-(.+)$/);
    if (mCustom) return `custom-${mCustom[1]}`;
    const mRi = cls.match(/^ri-(.+)$/);
    if (mRi) return `remix-${mRi[1]}`;
    const mTi = cls.match(/^ti-(.+)$/);
    if (mTi) return `tabler-outline-${mTi[1]}`;
    return null;
}

function upgradeOne(el) {
    if (!el || el.dataset.iconUpgraded === '1') return;

    const classes = Array.from(el.classList);
    let symbolId = null;
    for (const cls of classes) {
        const id = classToSymbolId(cls);
        if (id) {
            symbolId = id;
            break;
        }
    }
    if (!symbolId) return;

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    Array.from(el.attributes).forEach(attr => {
        if (attr.name.toLowerCase() === 'class') return;
        svg.setAttribute(attr.name, attr.value);
    });

    if (!svg.hasAttribute('aria-hidden') && !svg.hasAttribute('role') && !svg.hasAttribute('aria-label')) {
        svg.setAttribute('aria-hidden', 'true');
    }

    svg.classList.add(...classes);

    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttribute('href', `${SPRITE}#${symbolId}`);
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', `${SPRITE}#${symbolId}`);
    svg.appendChild(use);

    el.dataset.iconUpgraded = '1';
    el.replaceWith(svg);
}

function upgradeIcons(root) {
    (root || document).querySelectorAll('i.icon').forEach(upgradeOne);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => upgradeIcons(document));
} else {
    upgradeIcons(document);
}

const mo = new MutationObserver(muts => {
    muts.forEach(m => {
        m.addedNodes && m.addedNodes.forEach(n => {
            if (n && n.querySelectorAll) upgradeIcons(n); else if (n && n.nodeType === 1 && n.matches && n.matches('i.icon')) upgradeOne(n);
        });
    });
});
mo.observe(document.documentElement, {childList: true, subtree: true});

export {upgradeIcons};
